import React from 'react'
import { store } from './rematch/store'
import { Provider } from 'react-redux'
import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from 'react-router-dom'
import Home from './components/Home/Home'
import Article from './components/Articles/Article'
import Gyms from './components/Articles/Gyms'
import Articles from './components/Articles/Articles'
import Bogota from './components/Pages/Pages'
import Subway from './components/Pages/Subway'
import Listing from './components/Pages/Listing'
import Portfolio from './components/Pages/Portfolio'
import MobileApp from './components/Pages/MobileApp'
import Neighbors from './components/Pages/Neighbors'
import Matadepera from './components/Pages/Matadepera'
import Graphics from './components/Graphics/Graphics'
import ScrollToTop from "./components/elements/ScrollToTop";
import Consulting from './components/Pages/Consulting'

const router = createBrowserRouter(
    createRoutesFromElements(<>
        <Route path='/' element={<><Home/><Portfolio/></>}/>
            <Route path='/bogota' element={<Bogota/>}/>
            <Route path='/neighbors' element={<Neighbors/>}/>
            <Route path='/matadepera' element={<Matadepera/>}/>
            <Route path='/barcelona' element={<MobileApp/>}/>
            <Route path='/narratives' element={<Articles/>}/>
            <Route path='/graphics' element={ <><Home/><Graphics/></> }/>
            <Route path='/subway' element={<Subway/>}/>
            <Route path='/narratives/cluster' element={<Article/>}/>
            <Route path='/narratives/gyms' element={<Gyms/>}/>
            <Route path='/rooms/' element={<Listing/>}/>
            <Route path='/consulting' element={<Consulting/>}/>
        </>
    )
)

const AppWithRouterAccess = () => {
    return (
        <Provider store={ store }>
            <React.StrictMode>
                <RouterProvider router={ router }/>
            </React.StrictMode>
        </Provider>
    )
}
export default AppWithRouterAccess
